import React, { Component } from "react";
import { connect } from "react-redux";
import { logOut } from "../../store/actions/customer";
import { Link } from "react-router-dom";
import Widget from "../../components/shared/Widget";
import styles from "../../thema/style";
import { withRouter } from "react-router";
import calculatePrice from "../../helpers/calculatePrice";
import activeDiscount from "../../helpers/activeDiscount";
import { fetchCurrentPrices } from "../../utils/cartSync";

class CartWidget extends Component {
  state = {
    validatedItems: null,
  };

  componentDidMount() {
    if (this.props.cart.items && this.props.cart.items.length > 0) {
      this.fetchPrices();
    }
  }

  componentDidUpdate(prevProps) {
    const prevLength = prevProps.cart.items ? prevProps.cart.items.length : 0;
    const currentLength = this.props.cart.items ? this.props.cart.items.length : 0;

    if (prevLength !== currentLength && currentLength > 0) {
      this.fetchPrices();
    }
  }

  fetchPrices = async () => {
    const result = await fetchCurrentPrices(this.props.cart.items);
    this.setState({
      validatedItems: result.items,
    });
  };

  getValidatedItem = (item) => {
    if (this.state.validatedItems) {
      const validated = this.state.validatedItems.find(v => v.id === item.id);
      if (validated) {
        return validated;
      }
    }
    return item;
  };

  getCurrentPrice = (item) => {
    const validated = this.getValidatedItem(item);
    return validated.current_price || validated.sale_price || validated.price;
  };
  calculateCustomerDiscount = (subtotal) => {
    const { customer } = this.props.customer;

    if (
      !customer ||
      !customer.discount_enabled ||
      subtotal < customer.min_cart_amount
    ) {
      return 0;
    }

    if (customer.discount_type === "percentage") {
      return subtotal * (customer.discount_value / 100);
    } else if (customer.discount_type === "fixed") {
      return customer.discount_value;
    }

    return 0;
  };

  render() {
    const cartTotalDiscountPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((product) => {
                const validatedProduct = this.getValidatedItem(product);
                return parseFloat(
                  calculatePrice(validatedProduct, activeDiscount(product.categories))
                );
              })
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    const cartTotalPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((item) => {
                const quantity = parseInt(item.quantity) || 0;
                const price = parseFloat(this.getCurrentPrice(item)) || 0;
                return quantity * price;
              })
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    const customerDiscount = this.calculateCustomerDiscount(cartTotalDiscountPrice);
    const finalCartPrice = cartTotalDiscountPrice - customerDiscount;

    return (
      this.props.cart.items.length > 0 && (
        <Widget title={"SEPETİM"}>
          <div className={styles.orderSummary}>
            <ul>
              <li>
                <strong>
                  Toplam{" "}
                  {this.props.cart.items.length > 0
                    ? this.props.cart.items
                        .map((v) => v.quantity)
                        .reduce((a, b) => a + b)
                    : 0}{" "}
                  Ürün
                </strong>
              </li>
              <li>
                Ara Toplam:
                <span> ₺{parseFloat(cartTotalPrice).toFixed(2)}</span>
              </li>

              {finalCartPrice > 0 ? (
                <li>
                  Kargo:
                  <span>
                    ₺
                    {parseFloat(
                      this.props.setting.setting.shipping_cost
                    ).toFixed(2)}
                  </span>
                </li>
              ) : null}

              {finalCartPrice >=
              this.props.setting.setting.free_shipping ? (
                <li style={{ display: "flex", flexDirection: "column" }}>
                  {parseFloat(this.props.setting.setting.free_shipping).toFixed(
                    2
                  )}{" "}
                  TL ve Üzeri Ücretsiz Kargo:
                  <span style={{ color: "#c00", alignSelf: "flex-end" }}>
                    -₺
                    {parseFloat(
                      this.props.setting.setting.shipping_cost
                    ).toFixed(2)}
                  </span>
                </li>
              ) : null}

              {cartTotalPrice - cartTotalDiscountPrice > 0 ? (
                <li>
                  Sepette İndirim:
                  <span style={{ color: "#c00" }}>
                    -₺
                    {parseFloat(
                      cartTotalPrice - cartTotalDiscountPrice
                    ).toFixed(2)}
                  </span>
                </li>
              ) : null}

              {customerDiscount > 0 ? (
                <li>
                  Premium Müşteri İndirimi:
                  <span style={{ color: "#c00" }}>
                    -₺{customerDiscount.toFixed(2)}
                  </span>
                </li>
              ) : null}

              {/* {cartTotalPrice > 0 ? (
                <li>
                  Kargo
                  <span> ₺{this.props.setting.setting.shipping_cost}</span>
                </li>
              ) : null} */}

              <li className={"sperator"} />
              <li>
                Toplam
                <span>
                  ₺{parseFloat(
                    finalCartPrice > 0
                      ? finalCartPrice +
                          (finalCartPrice >=
                          this.props.setting.setting.free_shipping
                            ? 0
                            : this.props.setting.setting.shipping_cost)
                      : 0
                  ).toFixed(2)}
                </span>
              </li>
            </ul>
            <div className={"text-right"}>
              <button
                onClick={(e) => {
                  e.preventDefault();

                  this.props.history.push({ pathname: "/sepet" });
                }}
                type={"button"}
              >
                Sepet Detayına Git
              </button>
            </div>
          </div>
        </Widget>
      )
    );
  }
}

const mapStateToProps = ({ cart, customer, setting }) => {
  return { cart, customer, setting };
};

const mapDispatchToProps = {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CartWidget)
);



// WEBPACK FOOTER //
// ./src/components/shared/CartWidget.js